import { useEffect } from "react";

// Injects JSON-LD structured data into <head> for SEO. Cleans up on unmount.
export const JsonLd = ({ id, data }) => {
  useEffect(() => {
    if (!data) return;
    const scriptId = `jsonld-${id}`;
    let el = document.getElementById(scriptId);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = scriptId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const node = document.getElementById(scriptId);
      if (node) node.remove();
    };
  }, [id, data]);
  return null;
};
